import {
  InMemoryHeader,
  InMemoryString,
} from "pbas-vue-components";


function getHeaders() {
  const headers = [
    new InMemoryHeader({
      type: new InMemoryString("Identifier"),
      visible: false,
      isIdentifier: true,
      allowVisibilityChange: false,
    }),
    new InMemoryHeader({
      title: "globals.member_group",
      type: new InMemoryString("MemberGroup"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "headers.left_drawer_menu_items.url",
      type: new InMemoryString("Url"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    })
  ]
  return headers;
}
export default getHeaders;
